import Navbar from '@components/landing/Navbar';
import Hero from '@components/landing/Hero';
import ProblemSection from '@components/landing/ProblemSection';
import TackledIt from '@components/landing/TackledIt';
import TackledImpact from '@components/landing/TackledImpact';
import ImpactMetrics from '@components/landing/ImpactMetrics';
import Stories from '@components/landing/Stories';
import Programs from '@components/landing/Programs';
import Newsletter from '@components/landing/Newsletter';
import Innovations from '@components/landing/Innovations';
import Report from '@components/landing/Report';
import VideoSection from '@components/landing/VideoSection';
import LegalAidCTA from '@components/landing/LegalAidCTA';
import JusticePerformance from '@components/landing/JusticePerformance';
import Blog from '@components/landing/Blog';
import VolunteersCTA from '@components/landing/VolunteersCTA';
import SocialMedia from '@components/landing/SocialMedia';
import Partners from '@components/landing/Partners';
import Testimonials from '@components/landing/Testimonials';
import Feedback from '@components/landing/Feedback';
import Footer from '@components/landing/Footer';
import ScrollToTop from '@components/ScrollToTop';

export default function Home() {
    return (
        <div className="page-scroll-root bg-white">
            <Navbar intro />
            <main className="w-full">
                <Hero />
                <ProblemSection />
                <TackledIt />
                <TackledImpact />
                <ImpactMetrics />
                <Stories />
                <Programs />
                <Newsletter />
                <Innovations />
                <Report />
                <VideoSection />
                <LegalAidCTA />
                <JusticePerformance />
                <Blog />
                <VolunteersCTA />
                <SocialMedia />
                <Partners />
                <Testimonials />
                <Feedback />
            </main>
            <Footer />
            <ScrollToTop />
        </div>
    );
}
